import { useRouter } from 'next/router'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
const mediaQuery = [{ screen: '(min-width: 280px)', width: '400px' }]
const AsideContent = ({
  gameLogoSrc,
  gameLogoAlt,
  ingress,
}: {
  gameLogoSrc: string
  gameLogoAlt: string
  heading: string
  ingress: string | React.ReactElement
  blackText?: boolean
  fullHeight?: boolean
}): React.ReactElement => {
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const isTablet = useCheckBreakpoint({ lt: Breakpoint.XL })
  const router = useRouter()
  const currentPath = router.asPath
  const isFromJuniorMath = currentPath.includes('junior')

  return (
    <div className="flex flex-col h-full md:w-3/5 lg:w-2/5 xl:w-1/2 items-center justify-center mx-auto">
      <ResponsiveImage
        alt={gameLogoAlt}
        fit="fill"
        height={isMobile ? 200 : isTablet ? 300 : 380}
        imageClassName={`block m-auto ${isFromJuniorMath ? '' : 'pb-4 lg:mt-4'}`}
        mediaQuery={mediaQuery}
        srcKey={gameLogoSrc}
        width={isMobile ? 200 : isTablet ? 312 : 370}
      />
      {!isMobile && (
        <p className="text-center mt-1  xl:-mr-4 md:w-3/4 lg:w-full lg:pb-5 lg:9/10  text-white lg:text-xl xl:text-2xl md:leading-8.5 font-poppins max-w-222">
          {ingress}
        </p>
      )}
    </div>
  )
}

export default AsideContent
